import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import { createMuiTheme } from '@material-ui/core/styles';
import { BrowserRouter } from 'react-router-dom';
import { configure } from 'mobx';
import { Provider } from 'mobx-react';
import DateFnsUtils from '@date-io/date-fns';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';

//Mobx stores
import commonStore from './mobx-stores/commonStore';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#0f7fd3'
    },
    dark: '#2d3547',
    primaryGray: '#666666',
    denim: '#1a2930',
    white: '#fff',
    turquoise: '#04bfa8',
    blue: '#0f7fd3',
    black: '#000000',
    lightGray: '#dedede',
    paleGray: '#f0f0f0',
    pastelOrange: '#ff944e',
    silver: '#d5dde0',
    greyishBrown: '#4a4a4a',
    warmGray: '#9b9b9b',


    //new colors
    bgColor: '#fcfcff',
    gray: '#747f87',
    paleGrayThree: '#d7e4f7',
    lightBlue: '#e8f5ff',
    green: '#78bb8b',
    red: '#fe6468',
    orange: '#f1a42c',
    paleGrayFour: '#f3f3f4',
    slateGray: '#585c64',
    powderBlue: '#d3e9fa',
    midBlue: '#0b68c6',
    darkGray: '#424242',
    warmGray2: '#888888',
    lightGray2: '#bfc5d2',
    paleGrayFive: '#f3f3f3',
    lightSilver: '#fbfbfc',
    paleGraySix: '#f3f5f7',
    whiteTwo: '#eeeeee',
    darkSkyBlue: '#4a90e2',
    darkGrayBlue: '#34475a',
    coolGray2: '#949ba8',
    white2: '#e6e6e6',
    coolGray: '#89969f',
    white3:'#fafafa',
    dullGray: '#acb4c6',
    dullGray2: '#f1f2f5',
    lightSilver2: '#f6f8f8',
    darkRed: '#de143c',
    darkGreen: '#698e22',
    darkOrange:'#ffa404'

  },
  typography: {
    button: {
      textTransform: 'none'
    },
    useNextVariants: true,
    fontFamily: 'Roboto',
  },
  overrides: {
    MuiInputLabel: { // Name of the component ⚛️ / style sheet
      root: { // Name of the rule
        color: "#00000",
        "&$focused": { // increase the specificity for the pseudo class
          color: "#00000"
        }
      }
    },
    MuiFilledInput: {
      root: {
        color: '#00000',
        borderRadius: '4px',
        backgroundColor: 'transparent',
        border: 'solid 1px #c5c1c0',
        paddingRight: '0px',
        paddingTop: '0px',
        "&$focused": { // increase the specificity for the pseudo class
          backgroundColor: "#fff", border: 'solid 1px #c5c1c0',
        },
        "&$disabled": {
          backgroundColor: '#fff',
          color: 'black',
          border: 'solid 1px #c5c1c0',
        },
      }

    },

  }
});

const stores = {
  commonStore,

 
};

configure({ enforceActions: 'observed' })

ReactDOM.render((
  <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ background: 'white' }}>
    <MuiThemeProvider theme={theme}>
      <Provider {...stores}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </MuiThemeProvider>
  </MuiPickersUtilsProvider>
), document.getElementById('root'));

serviceWorker.unregister();
